import { ReactElement } from 'react';
import { SelectField } from '@ff-it/form';
import { InvoiceType } from 'modules/invoicing/common/types';
import { Table, Tbody, Td, Th, Thead, Tr } from '@ff-it/ui';

const kindOptions = [
  {
    value: 'fakturrekins',
    label: 'Faktūrrēķins',
  },
  {
    value: 'invoice',
    label: 'Invoice',
  },
  {
    value: 'credit',
    label: 'Kredītrēķins',
  },
];

const endpointOptions = [
  {
    value: 'income',
    label: 'income',
  },
  {
    value: 'expense',
    label: 'expense',
  },
  {
    value: 'advance',
    label: 'advance',
  },
];

interface DocConfig {
  id?: number;
  type: InvoiceType;
  domain: 'LOCAL' | 'EU' | 'OTHER';
  kind: string;
  endpoint: string;
}

export interface DocumentProps {
  items: DocConfig[];
}

export function Documents({ items }: DocumentProps): ReactElement {
  return (
    <>
      <h5>Documents</h5>
      <Table>
        <Thead>
          <Tr>
            <Th>Type</Th>
            <Th>Domain</Th>
            <Th>Kind</Th>
            <Th>Endpoint</Th>
          </Tr>
        </Thead>
        <Tbody>
          {items.map(({ type, domain }, i) => (
            <Tr key={i}>
              <Td valign="middle">{type}</Td>
              <Td valign="middle">{domain}</Td>
              <Td>
                <SelectField name={`doc[${i}].kind`} options={kindOptions} simple size="sm" className="mb-0" />
              </Td>
              <Td>
                <SelectField name={`doc[${i}].endpoint`} options={endpointOptions} simple size="sm" className="mb-0" />
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </>
  );
}
